<ag-grid-angular [style.height]="height" class="ag-theme-alpine"
    [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" [rowData]="_rowData"  [rowSelection]="'multiple'"
    [animateRows]="true"  (gridColumnsChanged)="onGridReady($event)"  [gridOptions]="gridOptions"></ag-grid-angular>